import {
  Component,
  ElementRef,
  Renderer2,
  OnDestroy,
  DOCUMENT,
  inject
} from '@angular/core';
import {
  CoreActionLoadMenu,
  CoreActionSetMenuReloadRequired,
  CorePageModuleIDs,
  CoreRouterActionNavigateToPageModule,
  CoreRouterNavigationIntent,
  selectorCoreMenuReloadRequired
} from '@bepatient/core';
import { MenuController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'bepatient-burger-button',
  templateUrl: './burger-button.component.html',
  styleUrls: ['./burger-button.component.scss'],
  standalone: false
})
export class BurgerButtonComponent implements OnDestroy {
  private menuController = inject(MenuController);
  private store = inject<Store<any>>(Store);
  private themeService = inject(ThemeService);

  themeColor: string = 'light';
  private themeSubscription: Subscription;

  constructor() {
    const el = inject(ElementRef);
    const renderer = inject(Renderer2);
    const document = inject(DOCUMENT);

    if (document.dir === 'rtl') {
      renderer.addClass(el.nativeElement, 'bp-rtl');
    }

    // Subscribe to theme changes
    this.themeColor = this.themeService.getCurrentThemeColor();
    this.themeSubscription = this.themeService
      .getThemeColor()
      .subscribe(themeColor => {
        this.themeColor = themeColor;
      });
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  openMenu(): void {
    // Checking Menu required reload or not
    this.store
      .pipe(select(selectorCoreMenuReloadRequired), take(1))
      .subscribe(required => {
        if (required) {
          this.store.dispatch(new CoreActionLoadMenu());
          this.store.dispatch(new CoreActionSetMenuReloadRequired(false));
        }
      });

    this.store.dispatch(
      new CoreRouterActionNavigateToPageModule({
        id: CorePageModuleIDs.MENU,
        pageIndex: 0,
        intent: CoreRouterNavigationIntent.FORWARD
      })
    );
  }
}
